<div class="page-inner-body portlet light">
    <div class="portlet-body">
        <!-- Table toolbar -->
        <div class="table-toolbar">
            <div class="row">
                <div class="col-md-12">
                    <!-- Toolbar with "View logs" label -->
                    <p-toolbar>
                        <div class="p-toolbar-group-start" style="font-size:x-large;">{{ 'applicationLog.viewApplicationLogs' | transloco }}</div>
                    </p-toolbar>
                </div>
            </div>
            <!-- Responsive table container -->
            <div class="table-responsive mt-3">
                <!-- PrimeNG table here -->
                <p-table #dt [value]="logs" [lazy]="true" (onLazyLoad)="getLazyApplicationLogs($event)" dataKey="Id" [rowHover]="true" [loading]="loading"
                    styleClass="p-datatable-gridlines p-datatable-striped"
                    [globalFilterFields]="['Message']" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                    [reorderableColumns]="true" [resizableColumns]="false" selectionMode="single">
                    <ng-template pTemplate="caption">
                        <div class="table-header">
                          <div class="row d-flex align-items-center">
                            <div class="col-8">
                              <div
                                class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                                <button type="button"
                                  class="bg-transparent border-0 py-2 px-3 d-flex align-items-center justify-content-center position-absolute">
                                  <i class="text-muted fa fa-search  icon-block icon-block--search-blue is--small"></i>
                                </button>
                                <input type="text"
                                  class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                                  (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                  [placeholder]="'applicationLog.search' | transloco" />
                              </div>
                            </div>
                            <div class="col-4"></div>
                          </div>
                        </div>
                      </ng-template>
                    <!-- Header template -->
                    <ng-template pTemplate="header" let-rowIndex="rowIndex" let-rowData>
                        <tr>
                            <th [pSortableColumn]="'Level'" style="width: 140px;">{{ 'applicationLog.level' | transloco }} <p-sortIcon [field]="'Level'"></p-sortIcon></th>
                            <th [pSortableColumn]="'Message'">{{ 'applicationLog.message' | transloco }} <p-sortIcon [field]="'Message'"></p-sortIcon></th>
                            <!-- <th [pSortableColumn]="'Exception'">Exception <p-sortIcon
                                    [field]="'Exception'"></p-sortIcon></th> -->
                            <th [pSortableColumn]="'TimeStamp'" style="width: 200px;">{{ 'applicationLog.date' | transloco }} <p-sortIcon [field]="'TimeStamp'"></p-sortIcon></th>
                        </tr>
                    </ng-template>
                    <!-- Body template -->
                    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
                        <tr>
                            <td>{{rowData.Level}}</td>
                            <td [ngClass]="getRowStyle(rowData)">{{rowData.Message}}</td>
                            <!-- <td>{{rowData.MessageTemplate}}</td> -->
                            <td>{{rowData.TimeStamp | date: 'dd/MM/yyyy HH:mm'}}</td>
                        </tr>
                    </ng-template>
                    <!-- Empty message template -->
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="4">
                                <div class="text-center">{{ 'applicationLog.noRecordsFound' | transloco }}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
